import { config } from '../Configurations';
import branch from 'branch-sdk';

export const createBranchIOLink = branchConfig => {
    return new Promise((resolve, reject) => {
        branch.init(config.branchIOKey, (err, data) => {
            branch.link(
                {
                    tags: ['tag1', 'tag2'],
                    channel: 'facebook',
                    feature: 'dashboard',
                    stage: 'new user',
                    data: branchConfig,
                },
                (err, link) => {
                    resolve(link);
                },
            );
        });
    });
};

export const parseBranchIOLink = () => {
    return new Promise((resolve, reject) => {
        branch.init(config.branchIOKey, (err, data) => {
            resolve(data);
        });
    });
};



// WEBPACK FOOTER //
// ./src/Utils/branchIOHelper.js